// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"a59f6be4","295":"ebb4f503","297":"9e5ede42","943":"876723de","946":"33513908"}[chunkId] + ".chunk.css";
};